import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { MagicLinkUserRepository } from '../infra/MagicLinkUserRepository'

export type GetMagicLinkTokenFactoryDependencies = {
  repository: MagicLinkUserRepository
}

export function getMagicLinkTokenFactory({ repository }: GetMagicLinkTokenFactoryDependencies) {
  return function getMagicLinkTokenImpl() {
    return repository.getLocalToken()
  }
}

export function getMagicLinkToken() {
  const storage = new LocalStorageClient()
  const repository = new MagicLinkUserRepository({ storage })
  const getToken = getMagicLinkTokenFactory({ repository })

  return getToken()
}
